import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-loading-icon-only"
}
const _hoisted_2 = {
  key: 1,
  class: "as-loading"
}


const __default__ = {};

interface IProps {
  iconOnly?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Loading',
  props: {
    iconOnly: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.iconOnly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "https://cdn.lfastcdn.com/2025/10/loading.gif",
          border: "0"
        }, null, -1)
      ])))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
        _createTextVNode(" Đang tải, vui lòng chờ lại "),
        _createElementVNode("br", null, null, -1),
        _createElementVNode("br", null, null, -1),
        _createElementVNode("img", {
          src: "https://cdn.lfastcdn.com/2025/10/loading.gif",
          border: "0"
        }, null, -1),
        _createElementVNode("br", null, null, -1),
        _createElementVNode("br", null, null, -1),
        _createTextVNode(" Sau khi hiển thị, trang web được làm mới tự động, bạn không cần làm mới trang tận tay. "),
        _createElementVNode("br", null, null, -1)
      ])))
}
}

})